import { render, staticRenderFns } from "./userPopper.vue?vue&type=template&id=6e513ae2&"
import script from "./userPopper.vue?vue&type=script&lang=js&"
export * from "./userPopper.vue?vue&type=script&lang=js&"
import style0 from "./userPopper.vue?vue&type=style&index=0&id=6e513ae2&prod&lang=scss&"
import style1 from "./userPopper.vue?vue&type=style&index=1&id=6e513ae2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports